var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      display: "block",
      shapeRendering: "auto"
    },
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-1.3568521031207599s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-1.3568521031207599s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.23760598493544,66.21922452366792)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(32.72727272727273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.9090909090909091
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-1.2211668928086838s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-1.2211668928086838s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.462450390056595,77.28895986063554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(65.45454545454545)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.8181818181818182
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-1.0854816824966078s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-1.0854816824966078s"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.73055485180145,79.69464325642798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(98.18181818181817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.7272727272727273
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9497964721845319s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9497964721845319s"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.35417798164145,72.67248723062775)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(130.9090909090909)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.6363636363636364
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8141112618724559s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8141112618724559s"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.215210791565077,58.45197670524289)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(163.63636363636365)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.5454545454545454
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6784260515603799s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6784260515603799s"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.215210791565077,41.548023294757115)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(196.36363636363635)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.45454545454545453
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5427408412483039s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5427408412483039s"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.354177981641442,27.327512769372255)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(229.0909090909091)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.36363636363636365
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.40705563093622793s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.40705563093622793s"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.73055485180144,20.30535674357202)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(261.8181818181818)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.2727272727272727
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.27137042062415195s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.27137042062415195s"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.46245039005658,22.711040139364442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(294.54545454545456)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.18181818181818182
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.13568521031207598s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.13568521031207598s"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.23760598493544,33.78077547633208)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(327.2727272727273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#982068",
    fillOpacity: 0.09090909090909091
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "1.44 1.44;1 1",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.4925373134328357s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6bc5a1dfa031b98d9766a1b728e814a8.svg";
export { ForwardRef as ReactComponent };